import React from 'react';
import SourceShaperLogo from '../images/source-shaper-logo.svg';

const Logo = () => (
  <img src={SourceShaperLogo} alt='Source Shaper' />
)

export default Logo;
